import React, { useState, Component, forwardRef, useImperativeHandle } from 'react';
import { connect } from 'react-redux'
import * as actions from '@/models/orders/actions'
import cn from 'classnames';
import { Dropdown, Menu, Icon, Button, message, Form, Input, Select } from 'antd';
import styles from './style.module.less';
import * as utils from '@/utils';
import * as taskHallServices from '@/models/taskHall/services';
import { orderStatus } from '@/models/orders/defines/constants';
const isTenantMode = process.env.APP_MODE === 'tenant';
const isManagerMode = process.env.APP_MODE === 'manager';

function SearchForm(props, ref) {
  const { form, onChangeSearchData, size = 'default' } = props
  const { getFieldDecorator, validateFields, getFieldValue } = form;
  useImperativeHandle(ref, () => ({
    searchData: (params) => {
      form.setFieldsValue({ keyword: params.keyword })
      handleSubmit(params.callback)
    }
  }))
  const handleSubmit = (callback,statusVal) => {
    validateFields((err, values) => {
      if (err) {
        if (type != 'status') {
          message.warning(err?.keyword?.errors[0]?.message)
        }
        return console.error(err)
      }
      console.log(values,statusVal)
      const params = {
        // type: isManagerMode ? 1 : 2,
        type: 5,
        status_code: statusVal == undefined?values.status_code:statusVal,
      }
      if (values.searchType == 1) {
        params.order_no = values.keyword
      } else if (values.searchType == 2) {
        params.message = values.keyword
      }
      console.log(params)
      const hide = message.loading('加载中...', 0);
      taskHallServices.fetchTask(params).then(result => {
        typeof onChangeSearchData == 'function' && onChangeSearchData(result)
        typeof callback == 'function' && callback(result)
      }).catch((err) => {
        message.error(err?.message || '获取列表失败，请刷新重试');
      }).finally(() => { hide() });
    });
  }
  return (
    <div>
      <Form>
        <div className={styles.box}>
          <div className={styles.item}>
            <Input.Group compact >
              {getFieldDecorator('searchType', {
                initialValue: 1,
              })(
                <Select size={size} style={{ width: size == 'small' ? '90px' : '110px' }}>
                  <Select.Option value={1}>工单详情</Select.Option>
                  <Select.Option value={2}>聊天历史</Select.Option>
                </Select>
              )}
              {getFieldDecorator('keyword', {
                initialValue: '',
                rules: [
                  {
                    message: getFieldValue('searchType') == 1 ? '请输入工单号' : '请输入关键词',
                  },
                ],
              })(
                <Input size={size}
                  suffix={
                    <Icon type="search" style={{ color: '#17A55C' }} onClick={() => {
                      handleSubmit()
                    }} />
                  }
                  style={{ width: `calc(100% - ${size == 'small' ? '90px' : '110px'})` }}
                  placeholder={getFieldValue('searchType') == 1 ? '请输入工单号' : '请输入关键词'}
                  onPressEnter={() => { handleSubmit() }}
                />
              )}

            </Input.Group>
          </div>
          <div className={styles.item} style={{ width: size == 'small' ? '90px' : '110px', flex: 'none', marginLeft: '6px' }}>
            {getFieldDecorator('status_code', {
              initialValue: '',
            })(
              <Select size={size} style={{ width: '100%' }} onChange={(event) => { handleSubmit('status',event) }}>
                <Select.Option value={''}>全部状态</Select.Option>
                {Object.keys(utils.orderStatusMappings).filter(item => {
                  return [
                    orderStatus.WAIT_ASSIGN,
                    orderStatus.PROCESSING_WAIT_APPOINTMENT,
                    orderStatus.PROCESSING_WAIT_SERVICE,
                    orderStatus.WORKER_LOCATION_CHECKED,
                    orderStatus.PROCESSING_COMPLETED,
                    orderStatus.DONE_CLOSE,
                    orderStatus.CANCEL,
                    orderStatus.GUAQI,
                  ].includes(Number(item))
                }).map((key, index) => (
                  <Select.Option key={index} value={key}
                    title={utils.orderStatusMappings[key].text+key} >
                    {utils.orderStatusMappings[key].text}
                  </Select.Option>
                ))}
              </Select>
            )}
          </div>
        </div>
      </Form>
    </div>
  );
}

export default Form.create()(forwardRef(SearchForm))